import { apiService } from './api';

// Define Profile interface
export interface Profile {
    perfil_id: number;
    nome: string;
}

export const perfilService = {
    // Get all profiles
    async getProfiles(): Promise<Profile[]> {
        try {
            const response = await apiService.get<Profile[]>('/perfil');
            return response;
        } catch (error) {
            console.error('Error fetching profiles:', error);
            throw error;
        }
    }
};
